import { combineEpics } from "redux-observable";
import { bloggerEpic as mainBloggerEpic } from "./bloggerEpic";
import { bloggerCreatorEpic } from "./bloggerCreatorEpic";

export const bloggerEpic = combineEpics(mainBloggerEpic, bloggerCreatorEpic);